var exports = {
  "x6": "ToggleButton.module__button___T1B6X0",
  "vu": "ToggleButton.module__active___T1B6X0",
  "AD": "ToggleButton.module__inactive___T1B6X0",
};

module.exports = exports;
